<style>
    .el-message-box{
        width: 800px;
        height: 300px;
    }
</style>
<template>

    <div>
        <list-template :queryParams="formInline" @onDataFilter="onDataFilter" actionUrl="channel/findChannels.action"
                       ref="list-template">
            <template scope="scope" slot="searchButton">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-select @change="$refs['list-template'].search()" clearable placeholder="合作状态"
                                   v-model="formInline.status">
                            <el-option label="正常合作" value="1"></el-option>
                            <el-option label="取消合作" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-select @change="$refs['list-template'].search()" clearable placeholder="合作状态"
                                   v-model="formInline.cooperation">
                            <el-option label="有合作渠道" value="1"></el-option>
                            <el-option label="没有合作渠道" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-select @change="$refs['list-template'].search()" clearable placeholder="请选择排序规则"
                                   v-model="formInline.order">
                            <el-option :value="1" label="创建时间由近到远"></el-option>
                            <el-option :value="2" label="最近登录时间由近到远"></el-option>
                            <el-option :value="3" label="昨日PV由高到低"></el-option>
                            <el-option :value="4" label="昨日UV由高到低"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <employee-select @clear="clear" @onEmployeeSelected="onEmployeeSelectedQuery"
                                         placeholder="请选择维护人"></employee-select>
                    </el-form-item>

                    <el-form-item>
                        <el-input placeholder="渠道名称/地区/联系方式" v-model="formInline.queryParam"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker @change="onCreateTimeChange" end-placeholder="选择创建结束时间"
                                        start-placeholder="选择创建起始时间"
                                        type="daterange" v-model="formInline.createTime">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="$refs['list-template'].search()" type="primary">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="$router.push({ name: '添加渠道'})" type="primary">新增渠道</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="exportExcel()" type="warning">导出</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template scope="scope" slot="item">
                <el-card class="basic-margin" v-bind:key="index" v-for="(data,index) in scope.datas">
                    <el-row>
                        <el-col :lg="15" :md="15" :sm="17" :span="9" :xl="20" :xs="20">
                            <h4><b>{{data.channelPageName?data.channelPageName:''}}</b>
                                <el-tag :type="data.status==1?'success':'info'" size="mini" style="margin-left:10px;">
                                    {{data.status==1?'正常合作':'取消合作'}}
                                </el-tag>
                                <el-tag size="mini" style="margin-left:10px;" type="warning"
                                        v-if="data.maintainWorkerName">{{data.maintainWorkerName}}
                                </el-tag>
                                <el-tag :type="data.qrcode?'success':'info'" size="mini" style="margin-left:10px;">
                                    {{data.qrcode?'已上传二维码':'未上传二维码'}}
                                </el-tag>
                                <el-tag size="mini" style="margin-left:10px;" type="warn">{{data.roleName}}</el-tag>

                            </h4>
                        </el-col>
                        <el-col :lg="8" :md="8" :offset="1" :sm="6" :span="14" :xl="3" :xs="15">

                            <el-dropdown trigger="click">
                                <el-button class="el-dropdown-link" size="mini" type="primary">
                                    更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="$router.push({ name: '修改渠道',params:{id:data.id}})">
                                        编辑
                                    </el-dropdown-item>
                                    <!-- <el-dropdown-item @click.native="changeDel(data.id)">删除</el-dropdown-item> -->
                                    <el-dropdown-item @click.native="changeState(data.id, data.status===1?0:1)">
                                        {{data.status===1?'取消合作':'重新合作'}}
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="showdistributionDialog(data)">分配维护人
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="showUpdatePasswordDialog(data)">修改登录密码
                                    </el-dropdown-item>
                                  <el-dropdown-item @click.native="showUpdateLonginAccountDialog(data)">修改登录账户
                                  </el-dropdown-item>
                                    <el-dropdown-item @click.native="showAccountInfo(data)">查看账号信息</el-dropdown-item>
                                    <el-dropdown-item @click.native="settingFree(data)">设置分佣比例</el-dropdown-item>
                                   <!-- <el-dropdown-item @click.native="closeContacts(data)">
                                        {{data.isConnection==0?'开启联系收费':'关闭联系收费'}}
                                    </el-dropdown-item>-->
                                    <el-dropdown-item @click.native="showSettingChannelQr(data)">添加渠道公众号
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="settingRole(data.id,data.roleName)">设置角色
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                            @click.native="$router.push({ path: 'weChartPayConfig',query:{id:data.id}})">
                                        设置商户号
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-col>
                    </el-row>
                    <el-row :gutter="2">
                        <el-col :md="4" :sm="8" :span="6">
                            <p>{{ data.channelName }}({{data.fansCount?data.fansCount+'万':'0'}}用户)</p>
                            <p>{{data.areaName}}</p>
                            <p><span
                                    v-if="data.abutmentPhone">{{data.abutmentPersonName}}  {{data.abutmentPhone}}</span>
                                <span v-else>联系方式：无</span></p>
                        </el-col>
                        <el-col :md="4" :sm="8" :span="6">
                            <p>创建时间：{{data.createTime|dateFormat}}</p>
                            <p>到期时间：{{data.deadline|dateFormat}}</p>
                            <p>最近登录：{{data.loginTime | dateFormat}}</p>
                        </el-col>
                        <el-col :md="4" :sm="8" :span="6">
                            <p>昨日PV {{data.yesterdayPv}} | 昨日UV {{data.yesterdayUv}} </p>
                            <p>用户总数：{{data.allUserCount}}（月活跃 {{data.lastMonthUserCount}}）</p>
                            <p>入驻商家：{{data.businessAllCount}} 家</p>
                        </el-col>
                    </el-row>
                </el-card>
            </template>
        </list-template>

        <el-form :model="distributionForm" :rules="distributionRules" class="demo-ruleForm"
                 editAction="channel/distributionMaintainWorker.action" label-width="120px" ref="ruleForm" v-form>
            <el-dialog :visible.sync="distributionDialog" size="tiny" title="分配维护人">

                <el-form-item label="员工：" prop="name">
                    <employee-select @onEmployeeSelected="onEmployeeSelected"></employee-select>
                </el-form-item>

                <span class="dialog-footer" slot="footer">
          <el-button @click="distributionDialog = false">取 消</el-button>
          <el-button type="primary">确 定</el-button>
        </span>

            </el-dialog>
        </el-form>

        <el-dialog :visible.sync="settingChannelQrDialog" title="添加渠道公众号二维码" width="30%">
            <el-form :model="settingChannelQrForm" :rules="qrRules" @onEdited="onQrEdited"
                     class="demo-ruleForm" editAction="channel/settingChannelQr.action" label-width="50px"
                     ref="ruleForm"
                     v-form>
                <el-form-item>
                    <p style="color:red;">用于在汽车网前端引导用户关注渠道公众号，帮助渠道引流，以及快捷进入渠道汽车网（所以需联系渠道，将汽车网放入公众号菜单和关注回复文案中）</p>
                </el-form-item>
                <el-form-item prop="qr">

                    <el-upload
                            :action="baseUrl+'upload/uploadPic'"
                            :data="{floder:'carExhibition'}"
                            :show-file-list="false"
                            class="avatar-uploader"
                            v-model="settingChannelQrForm.qr">
                        <img :src="settingChannelQrForm.qr.url"
                             class="avatar" v-if="settingChannelQrForm.qr&&settingChannelQrForm.qr.url">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                    <div style="color:#999;">点击图片 添加/修改，建议尺寸150*150</div>
                </el-form-item>

                <el-form-item>
                    <el-button @click="settingChannelQrDialog = false">取 消</el-button>
                    <el-button type="primary">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>

        <el-form :model="settingFreeForm" :rules="distributionRules" @onEdited="onEdited"
                 class="demo-ruleForm" editAction="channel/settingPrivateCarShareRate.action" label-width="80px"
                 ref="ruleForm" v-form>
            <el-dialog :visible.sync="settingFreeDialog" size="mini" title="设置渠道获得分佣比例" width="30%">

                <p>
                    <span style="color:red">温馨提示</span>
                    用于保证渠道业务收费获得的收益，修改保存后立即生效（比如修改之前所有的收入还是按照原比例计算，修改后产生的收入按照新的比例计算）
                </p>

                <el-input-number placeholder="请输入0-100之间的整数" size="medium"
                                 v-model="settingFreeForm.privateCarShareRate"></el-input-number>
                %

                <span class="dialog-footer" slot="footer">
          <el-button @click="settingFreeDialog = false">取 消</el-button>
          <el-button type="primary">确 定</el-button>
        </span>

            </el-dialog>
        </el-form>
        <el-form :model="settingRoleForm" :rules="distributionRules" @onEdited="onRoleEdited" class="demo-ruleForm"
                 editAction="channel/settingRole.action" label-width="80px" ref="roleForm" v-form>
            <el-dialog :visible.sync="settingRoleDialog" size="mini" title="设置渠道角色" width="30%">

                <el-select placeholder="角色" v-model="settingRoleForm.roleName">
                    <el-option label="二手车渠道" value="二手车渠道"></el-option>
                    <el-option label="汽车网渠道" value="汽车网渠道"></el-option>
                    <el-option label="社群渠道" value="社群渠道"></el-option>
                    <el-option label="加油渠道(单企版)" value="加油渠道(单企版)"></el-option>
                    <el-option label="汽车网+加油渠道(单企版)" value="汽车网+加油渠道(单企版)"></el-option>
                    <el-option label="二手车+加油渠道(单企版)" value="二手车+加油渠道(单企版)"></el-option>
                    <el-option label="加油渠道(平台版)" value="加油渠道(平台版)"></el-option>
                    <el-option label="汽车网+加油渠道(平台版)" value="汽车网+加油渠道(平台版)"></el-option>
                    <el-option label="二手车+加油渠道(平台版)" value="二手车+加油渠道(平台版)"></el-option>
                    <el-option label="线索渠道" value="线索渠道"></el-option>
            </el-select>
                <span class="dialog-footer" slot="footer">
          <el-button @click="settingRoleDialog = false">取 消</el-button>
          <el-button type="primary">确 定</el-button>
        </span>

            </el-dialog>
        </el-form>

        <el-form :model="passwordForm" :rules="passwordRules" class="demo-ruleForm"
                 editAction="channel/updateChannelPassword.action"
                 label-width="120px" ref="ruleForm" v-form>
            <el-dialog :visible.sync="updatePasswordDialog" size="tiny" title="修改登录密码">

                <el-form-item label="登录账号：" prop="name">
                    <el-input :disabled="true" v-model="passwordForm.account"></el-input>
                </el-form-item>

                <el-form-item label="设置新密码：" prop="password">
                    <el-input type="password" v-model="passwordForm.password"></el-input>
                </el-form-item>

                <span class="dialog-footer" slot="footer">
          <el-button @click="updatePasswordDialog = false">取 消</el-button>
          <el-button type="primary">保 存</el-button>
        </span>

            </el-dialog>
        </el-form>
      <el-form :model="loginAccountForm" :rules="loginAccountRules" class="demo-ruleForm"
               editAction="channel/updateChannelLoginAccount.action"
               label-width="120px" ref="loginAccountForm" v-form>
        <el-dialog :visible.sync="updateLonginAccountDialog" size="tiny" title="修改登录账户">

          <el-form-item label="登录账号：" prop="loginAccount" >
            <el-input  v-model="loginAccountForm.loginAccount"></el-input>
          </el-form-item>

          <span class="dialog-footer" slot="footer">
          <el-button @click="updateLonginAccountDialog = false">取 消</el-button>
          <el-button type="primary">保 存</el-button>
        </span>

        </el-dialog>
      </el-form>
    </div>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import ChannelModel from '@/framework/models/channelModel'
import saveChannel from './children/saveChannel'
import ListTemplate from '@/components/ListTemplate'
import tooltipCommon from '@/components/tooltipCommon'
import EmployeeSelect from '@/components/EmployeeSelect'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'channel-management',
  extends: BasicPager,
  data: function () {
    let validateLoginAccount = (rule, value, callback) => {
      let _this = this
      let vl = value + ''
      let match = vl.match(/[\u4E00-\u9FA5]/)

      if (match) {
        callback(new Error('登录账号不能为汉字！'))
      }

      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            callback(new Error('已存在该渠道账号，请重新输入！'))
          } else {
            callback()
          }
        }
      }
      ChannelModel.existsChannelAccount(_this, { channelAccount: value }, listener)
    }
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      passwordForm: {
        id: null,
        account: null,
        password: null
      },
      loginAccountForm: {
        id: null,
        loginAccount: null

      },
      settingFreeForm: {
        privateCarShareRate: 1,
        channelId: null
      },
      settingRoleForm: {
        id: null,
        roleName: null,
        channelId: null
      },
      distributionForm: {
        id: null,
        maintainWorkerId: null,
        maintainWorkerName: null
      },
      settingChannelQrForm: {
        id: null,
        qr: null
      },
      passwordRules: {
        password: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }
        ]
      },
      loginAccountRules: {
        loginAccount: [{ required: true, message: '登录账户' }, { max: 11, message: '登录账户不能大于11位！' }, { validator: validateLoginAccount, trigger: 'blur' }]

      },
      distributionRules: {
        employeeId: [{
          required: true,
          message: '请选择维护人',
          trigger: 'change'
        }]
      },
      settingMchIdRules: {
        mchId: [{
          required: true,
          message: '请输入微信商户号'
        }]
      },
      qrRules: {
        qr: [{
          required: true,
          message: '请上传渠道二维码'
        }]
      },
      formInline: {
        queryParam: '',
        region: '',
        createTime: '',
        startTime: null,
        endTime: null,
        order: 2,
        status: '1',
        maintainWorkerId: null,
        cooperation: null
      },
      settingChannelQrDialog: false,
      settingFreeDialog: false,
      settingRoleDialog: false,
      distributionDialog: false,
      updatePasswordDialog: false,
      updateLonginAccountDialog: false,
      datas: [],
      loading: false,
      currentPage: 1,
      total: 50,
      origin: window.location.origin
    }
  },
  components: {
    saveChannel,
    ListTemplate,
    EmployeeSelect,
    tooltipCommon
  },
  methods: {

    onQrEdited: function () {
      this.$message({
        message: '渠道二维码提交成功！',
        type: 'success'
      })
      this.settingChannelQrDialog = false
      this.$refs['list-template'].loadList()
    },
    onRoleEdited: function () {
      this.$message({
        message: '角色设置成功！',
        type: 'success'
      })
      this.settingRoleDialog = false

      this.$refs['list-template'].loadList()
    },

    showSettingChannelQr: function (data) {

      this.settingChannelQrDialog = true
      this.settingChannelQrForm.id = data.id
      if (data.qrcode) {
        this.settingChannelQrForm.qr = { url: this.baseImageUrl + data.qrcode }
      } else {
        this.settingChannelQrForm.qr = null
      }
    },
    settingFree: function (data) {
      this.settingFreeDialog = true
      this.settingFreeForm.channelId = data.id
      this.settingFreeForm.id = data.id
      this.settingFreeForm.privateCarShareRate = data.privateCarShareRate ? data.privateCarShareRate : 0
    },
    settingRole: function (id, roleName) {
      this.settingRoleForm.channelId = id
      this.settingRoleForm.id = id
      this.settingRoleForm.roleName = roleName
      this.settingRoleDialog = true
    },
    closeContacts: function (data) {
      let _this = this
      let params = {
        channelId: data.id,
        isConnection: data.isConnection === 1 ? 0 : 1
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message.success(dataInfo.errMsg)
          _this.$refs['list-template'].loadList()
        }
      }
      BasicModel.post(_this, '/channel/settingIsConnection.action', params, listener)
    },
    onEnableCarCoinChange: function (data) {
      let _this = this
      this.$confirm('此操作将' + (data.enableCarCoin === 0 ? '关闭' : '开启') + '用户的汽车币功能, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          channelId: data.id,
          enableCarCoin: data.enableCarCoin
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message.success(dataInfo.errMsg)
          }
        }
        ChannelModel.changeEnableCarCoin(_this, params, listener)
      }).catch(() => {
        let enableCarCoin = data.enableCarCoin === 1 ? 0 : 1
        data.enableCarCoin = enableCarCoin
      })
    },
    clear: function () {
      this.formInline.maintainWorkerId = null
      this.$refs['list-template'].loadList()
    },
    onCreateTimeChange: function () {
      let createTime = this.formInline.createTime

      if (createTime && createTime[0]) {
        this.formInline.startTime = createTime[0].getTime()
        this.formInline.endTime = createTime[1].getTime()
      } else {
        this.formInline.startTime = null
        this.formInline.endTime = null
      }

      this.$refs['list-template'].search()
    },
    onEmployeeSelectedQuery: function (item) {
      this.formInline.maintainWorkerId = item.id
      this.$refs['list-template'].loadList()
    },
    onEmployeeSelected: function (item) {
      this.distributionForm.maintainWorkerId = item.id
      this.distributionForm.maintainWorkerName = item.text
    },
    showdistributionDialog: function (data) {
      this.distributionForm.id = data.id
      this.distributionDialog = true
    },
    onEdited: function () {
      this.$message('提交成功')
      this.updatePasswordDialog = false
      this.updateLonginAccountDialog = false
      this.distributionDialog = false
      this.settingFreeDialog = false
      this.$refs['list-template'].loadList()
    },
    showUpdatePasswordDialog: function (data) {
      this.passwordForm.id = data.id
      this.passwordForm.account = data.loginAccount
      this.updatePasswordDialog = true
    },
    showUpdateLonginAccountDialog: function (data) {
      this.loginAccountForm.id = data.id
      this.loginAccountForm.loginAccount = data.loginAccount
      this.updateLonginAccountDialog = true
    },
    showAccountInfo: function (data) {
      const h = this.$createElement
      let body = h('div', null, [
        h('p', null, [
          h('span', null, '后台地址： '),
          h('span', {
            style: 'color: teal'
          }, 'https://' + window.location.hostname + '/clue/#/login/channel')
        ]),
        h('p', null, [
          h('span', null, '登录账号： '),
          h('span', {
            style: 'color: teal'
          }, data.loginAccount)
        ]),
        h('p', null, [
          h('span', null, '汽车网H5链接： '),
          h('a', {
            style: 'color: teal;'
          }, 'https://' + window.location.hostname + '/#/index?channelKey=' + data.channelMd5)
        ]),
        h('p', null, [
          h('span', null, '汽车网H5短链接： '),
          h('a', {
            style: 'color: teal;'
          }, data.shortUrl)
        ]),
        h('p', null, [
          h('span', null, '授权链接：'),
          h('a', {
            style: 'color:teal;'
          },
          data.serviceShortUrl
          )
        ]),
        h('p', null, [
          h('span', null, '省心车服H5链接：'),
          h('a', {
            style: 'color:teal;'
          },
          data.vipHomeShortUrl
          )
        ]),
        h('p', null, [
          h('span', null, '省心加油链接：'),
          h('a', {
            style: 'color:teal;'
          },
          data.gasHomeLink
          )
        ])

      ])
      this.$alert(body, '查看账号信息', {
        accountClass: 'msgBox',
        showConfirmButton: false,
        closeOnClickModal: true
      })
    },
    changeState: function (channelId, status) {
      let _this = this
      let msg = (status === 0 ? '关闭' : '开启')
      this.$confirm('您即将要' + msg + '链接, 是否继续?', '警告', {
        confirmButtonText: msg,
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              showClose: true,
              message: msg + '成功！',
              type: 'success'
            })
            _this.$refs['list-template'].search()
          }
        }
        ChannelModel.changeStatus(_this, {
          channelId: channelId,
          status: status
        }, listener)
      })
    },
    changeDel: function (channelId) {
      let _this = this

      this.$confirm('删除后将不再显示在列表，确认删除？', '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'success'
            })
            _this.$refs['list-template'].search()
          }
        }
        ChannelModel.changeChannelDel(_this, {
          channelId: channelId
        }, listener)
      })
    },
    onDataFilter: function (dataInfo) {
      for (var i = 0, temp = dataInfo.data.length; i < temp; i++) {
        let item = dataInfo.data[i]
        if (!item.remark) {
          continue
        }

        try {
          item.remark = JSON.parse(item.remark)
        } catch (e) {
          console.log('error' + e)
        }
      }
    },
    exportExcel: function () {
      let _this = this
      let params = {}
      let dataStr = JSON.stringify(params)

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + '/channel/exportExcel.action?param=' + encodeURI(dataStr) + '&token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath
    }
  }
}

</script>
